import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { message, Spin } from "antd";
import "./../style/common.css";

const SquareApplePayOnly = ({ amount, onSuccess }) => {
  const applePayRef = useRef(null);
  const statusRef = useRef(null);
  const [applePayInstance, setApplePayInstance] = useState(null);
  const [loading, setLoading] = useState(false);

  const appId = "sq0idp-X1EKrZj4nrq9JSVA_rtBCQ";
  const locationId = "L1FTNHJQ10EPQ";

  useEffect(() => {
    const initApplePay = async () => {
      if (!window.Square) {
        console.error("❌ Square SDK not loaded");
        return;
      }

      try {
        const payments = window.Square.payments(appId, locationId);

        const paymentRequest = payments.paymentRequest({
          countryCode: "AU",
          currencyCode: "AUD",
          total: {
            amount: amount.toFixed(2),
            label: "Mandurah Cafe Order",
          },
        });

        const applePay = await payments.applePay(paymentRequest);
        const canUse = await applePay.canMakePayment();

        if (!canUse) {
          applePayRef.current.innerHTML =
            "❌ Apple Pay not supported on this browser/device.";
          return;
        }

        await applePay.attach(applePayRef.current, {
          buttonType: "buy",
          buttonColor: "black",
        });

        setApplePayInstance(applePay);
        console.log("✅ Apple Pay ready");
      } catch (err) {
        console.error("Apple Pay init failed:", err);
        applePayRef.current.innerHTML = "❌ Apple Pay initialization failed.";
      }
    };

    initApplePay();
  }, [amount]);

  const handleApplePayClick = async () => {
    if (!applePayInstance) return;

    setLoading(true);
    const statusEl = statusRef.current;

    try {
      const result = await applePayInstance.tokenize();

      if (result.status === "OK") {
        const nonce = result.token;
        console.log("🍏 Apple Pay token:", nonce);

        const token = localStorage.getItem("token");
        const storedOrder = localStorage.getItem("pending_order_payload");

        if (!storedOrder) {
          message.error("Order info missing. Please try again.");
          return;
        }

        const payload = {
          ...JSON.parse(storedOrder),
          amount: (parseFloat(amount) || 0).toFixed(2),
          nonce,
          payment_mode: "apple_pay",
        };

        const res = await axios.post(
          "https://cafemandhurah.mandurahcafe.com.au/api/create-payment-and-order",
          payload,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (res.data?.success) {
          statusEl.innerHTML = "✅ Payment Successful";
          onSuccess(); // cleanup logic passed from parent
        } else {
          const errMsg = res.data?.message || "Payment failed.";
          statusEl.innerHTML = "❌ " + errMsg;
          message.error(errMsg);
        }
      } else {
        let errorMessage = `Tokenization failed: ${result.status}`;
        if (result.errors) {
          errorMessage += ` → ${JSON.stringify(result.errors)}`;
        }
        throw new Error(errorMessage);
      }
    } catch (err) {
      console.error("❌ Apple Pay Error:", err);
      statusEl.innerHTML = "❌ Payment Failed";
      message.error("Apple Pay transaction failed.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="apple-pay-only-wrapper">
      <h3>Pay with Apple Pay</h3>
      <div ref={statusRef} style={{ marginBottom: 10, fontSize: 14 }}></div>

      <div
        ref={applePayRef}
        onClick={handleApplePayClick}
        style={{
          cursor: "pointer",
          width: "100%",
          height: "48px",
          WebkitAppearance: "-apple-pay-button",
          WebkitAppearanceButton: "plain",
          WebkitAppearanceStyle: "black",
          display: "inline-block",
        }}
      ></div>

      {loading && (
        <div style={{ marginTop: 10 }}>
          <Spin tip="Processing Apple Pay..." />
        </div>
      )}
    </div>
  );
};

export default SquareApplePayOnly;
